{
  "user": {
    "form": {
      "addTitle": "Create User",
      "editTitle": "Edit User",
      "fields": {
        "username": "Username",
        "email": "Email",
        "fullName": "Full Name",
        "password": "Password",
        "confirmPassword": "Confirm Password",
        "facility": "Facility",
        "roles": "Roles",
        "active": "Active",
        "allFacilities": "All facilities (health-system-wide)",
        "globalAccessAck": "I understand this grants access to every facility",
        "departments": "Departments",
        "primaryDepartment": "Primary",
        "roleFacility": "Facility for {{role}}",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ another facility",
        "removeFacilityFromRole": "remove one",
        "otherRoles": "Other"
      },
      "errors": {
        "usernameMin": "Username must be at least {{min}} characters",
        "emailInvalid": "Invalid email address",
        "passwordMin": "Password must be at least {{min}} characters",
        "confirmPasswordRequired": "Please confirm your password",
        "passwordMismatch": "Passwords do not match",
        "rolesRequired": "At least one role is required",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "Confirm the health-system-wide grant before saving."
      },
      "submit": {
        "create": "Create User",
        "update": "Update User"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "User created successfully",
        "updatedSuccess": "User updated successfully",
        "saveError": "Failed to save user",
        "departmentsSaveError": "User saved, but the department assignment failed. Edit the user to retry."
      },
      "globalAccessWarning": "This grants access to patients at EVERY facility, not just paging reach. Use it only for genuinely health-system-wide staff, such as on-call cover.",
      "departmentsHint": "Where this account works. This is context and attribution — it grants no access to any patient.",
      "noDepartments": "No departments are configured yet."
    },
    "list": {
      "title": "User Management",
      "subtitle": "Manage system users, roles, and access",
      "columns": {
        "username": "Username",
        "fullName": "Full Name",
        "email": "Email",
        "roles": "Roles",
        "facility": "Facility",
        "status": "Status",
        "lastLogin": "Last Login",
        "actions": "Actions",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "Search users...",
        "allRoles": "All Roles",
        "allFacilities": "All Facilities",
        "allStatus": "All Status",
        "active": "Active",
        "inactive": "Inactive"
      },
      "actions": {
        "new": "Create User",
        "editTitle": "Edit user",
        "resetPasswordTitle": "Reset password",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "activateAria": "Activate user",
        "deactivateAria": "Deactivate user"
      },
      "lastLoginNever": "Never",
      "empty": "No users found matching your filters",
      "pagination": {
        "summary": "Showing {{from}}-{{to}} of {{total}}"
      },
      "toast": {
        "activated": "User {{username}} activated",
        "deactivated": "User {{username}} deactivated",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "All facilities",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "locked": "Locked",
      "pendingActivation": "Pending Activation"
    },
    "mfaStatus": {
      "enrolled": "Enrolled",
      "notEnrolled": "Not Enrolled",
      "exempt": "Exempt"
    }
  },
  "role": {
    "form": {
      "addTitle": "Create Role",
      "editTitle": "Edit Role",
      "fields": {
        "name": "Role Name",
        "code": "Role Code",
        "description": "Description",
        "category": "Category",
        "parentRole": "Parent Role (inherits permissions)"
      },
      "options": {
        "none": "None"
      },
      "errors": {
        "nameRequired": "Role name is required",
        "codeRequired": "Role code is required"
      },
      "submit": {
        "create": "Create Role",
        "update": "Update Role"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Role created",
        "updatedSuccess": "Role updated",
        "saveError": "Failed to save role"
      }
    },
    
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "source": {
      "own": "Own",
      "inherited": "Inherited",
      "category": "Category"
    },
    "permissions": {
      "ownTitle": "Edit Permissions",
      "deniedTitle": "Edit Denied Permissions",
      "ownSubtitle": "{{granted}} of {{total}} granted. Inherited and category-default permissions are shown in the Access Matrix; this page manages only the role's own grants.",
      "deniedSubtitle": "Denied permissions override grants from the role's own permissions, its parent roles, and its category defaults. Tick a permission to explicitly deny it for this role.",
      "invalidRoleId": "Invalid role id.",
      "save": "Save Permissions",
      "saveDenied": "Save Denied Permissions",
      "cancel": "Cancel",
      "toast": {
        "updatedSuccess": "Permissions updated",
        "deniedUpdatedSuccess": "Denied permissions updated",
        "saveError": "Failed to save permissions",
        "saveDeniedError": "Failed to save denied permissions"
      },
      "permissionGroup": {
        "analytics": "Analytics",
        "audit": "Audit",
        "billing": "Billing",
        "bloodProduct": "Blood Products",
        "consent": "Consent",
        "dietOrder": "Diet Orders",
        "discharge": "Discharge",
        "documentation": "Documentation",
        "encounter": "Encounters",
        "infection": "Infection Control",
        "licensing": "Licensing",
        "medication": "Medications",
        "notification": "Notifications",
        "order": "Orders",
        "patient": "Patient",
        "referral": "Referrals",
        "research": "Research",
        "restraint": "Restraints",
        "result": "Results",
        "scheduling": "Scheduling",
        "system": "System",
        "transfer": "Transfers",
        "user": "Users",
        "schedule": "Schedule",
        "admin": "Administration",
        "report": "Reports",
        "other": "Other"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "Create Category",
      "editTitle": "Edit Category",
      "fields": {
        "name": "Category Name",
        "code": "Category Code",
        "description": "Description",
        "sessionTimeout": "Session Timeout (minutes)",
        "maxFailedLogins": "Max Failed Logins",
        "mfaRequired": "Require MFA for this category"
      },
      "placeholders": {
        "code": "e.g. CLINICAL"
      },
      "errors": {
        "nameRequired": "Category name is required",
        "codeRequired": "Category code is required"
      },
      "submit": {
        "create": "Create Category",
        "update": "Update Category"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Category created",
        "updatedSuccess": "Category updated",
        "saveError": "Failed to save category"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "None",
      "basic": "Basic",
      "full": "Full",
      "paranoid": "Paranoid"
    },
    "permissions": {
      "title": "Default Permissions",
      "titleWithName": "Default Permissions — {{name}}",
      "subtitle": "Roles in this category inherit these permissions unless they explicitly deny them.",
      "invalidCategoryId": "Invalid category id.",
      "save": "Save Default Permissions",
      "cancel": "Cancel",
      "toast": {
        "updatedSuccess": "Default permissions updated",
        "saveError": "Failed to save default permissions"
      }
    }
  },
  "permission": {
    "action": {
      "view": "View",
      "viewSelf": "View Own",
      "viewRestricted": "View Restricted",
      "read": "Read",
      "write": "Write",
      "create": "Create",
      "update": "Update",
      "modify": "Modify",
      "delete": "Delete",
      "merge": "Merge",
      "discharge": "Discharge",
      "transfer": "Transfer",
      "approve": "Approve",
      "cosign": "Cosign",
      "sign": "Sign",
      "plan": "Plan",
      "manage": "Manage",
      "all": "All",
      "breakGlass": "Break-Glass",
      "export": "Export",
      "amend": "Amend",
      "administer": "Administer",
      "doubleCheck": "Double-Check",
      "reconcile": "Reconcile",
      "verbalVerify": "Verbal Verify",
      "verify": "Verify",
      "acknowledge": "Acknowledge",
      "prescribe": "Prescribe",
      "dispense": "Dispense",
      "cancel": "Cancel",
      "users": "Users",
      "roles": "Roles",
      "facilities": "Facilities",
      "system": "System",
      "audit": "Audit Log"
    }
  },
  "access": {
    "title": "Access Matrix",
    "subtitle": "Roles × permissions grid",
    "searchPermission": "Search permissions…",
    "searchRole": "Search roles…",
    "categoryFilter": "Category",
    "legend": {
      "own": "Own",
      "inherited": "Inherited",
      "category": "Category",
      "denied": "Denied",
      "none": "None"
    },
    "cellTooltip": {
      "hasOwn": "Granted directly",
      "hasInherited": "Inherited from parent role: {{source}}",
      "hasCategory": "Granted via category: {{source}}",
      "denied": "Explicitly denied",
      "none": "Not granted"
    },
    "inheritedFrom": "Inherited from {{source}}",
    "bulkEdit": {
      "title": "Bulk Edit",
      "applyTo": "Apply to selected",
      "selectedPermissions": "{{count}} permission(s)",
      "selectedRoles": "{{count}} role(s)",
      "actionGrant": "Grant",
      "actionDeny": "Deny",
      "actionClear": "Clear",
      "save": "Save changes",
      "cancel": "Cancel"
    },
    "emptyRoles": "No roles match the filter.",
    "emptyPermissions": "No permissions match the filter.",
    "loading": "Loading access matrix…",
    "permissionColumn": "Permission",
    "rolePicker": {
      "trigger": "Select roles to compare",
      "filterPlaceholder": "Filter roles…",
      "empty": "No roles match.",
      "groupAll": "All",
      "groupNone": "None",
      "footerSummary": "{{count}} of {{total}} selected",
      "selectAll": "Select all",
      "clear": "Clear"
    },
    "empty": {
      "selectRolesPrompt": "Select at least one role to compare.",
      "selectAllRoles": "Select all roles",
      "noPermissions": "No permissions found."
    },
    "legendCategoryDefault": "Category Default",
    "legendNotGranted": "Not Granted",
    "page": {
      "title": "Access Matrix",
      "subtitle": "View and manage roles, permissions, and access policies"
    },
    "tabs": {
      "matrix": "Access Matrix",
      "roles": "Role Management",
      "categories": "Category Management"
    },
    "roles": {
      "searchPlaceholder": "Search roles or permissions...",
      "createButton": "Create Role",
      "columns": {
        "role": "Role",
        "category": "Category",
        "parent": "Parent",
        "permissions": "Permissions",
        "users": "Users",
        "actions": "Actions"
      },
      "systemBadge": "System",
      "managePermissionsTitle": "Manage permissions",
      "manageDeniedTitle": "Manage denied permissions",
      "deniedBadge": "Denied",
      "editTitle": "Edit role",
      "deleteTitle": "Delete role",
      "expandAria": "Expand role",
      "collapseAria": "Collapse role",
      "effectivePermissions": "Effective Permissions",
      "noPermissionsAssigned": "No permissions assigned.",
      "empty": "No roles found.",
      "delete": {
        "title": "Delete Role",
        "description": "Are you sure you want to delete the role \"{{name}}\"? This action cannot be undone.",
        "confirm": "Delete"
      },
      "toast": {
        "deleted": "Role deleted",
        "deleteError": "Failed to delete role"
      }
    },
    "categories": {
      "subtitle": "Categories group roles and define shared policies (MFA, session limits).",
      "createButton": "Create Category",
      "requireMfa": "Require MFA",
      "yes": "Yes",
      "no": "No",
      "sessionTimeout": "Session Timeout",
      "sessionTimeoutMinutes": "{{count}} min",
      "maxFailedLogins": "Max Failed Logins",
      "manageDefaults": "Manage Default Permissions",
      "editTitle": "Edit",
      "editAria": "Edit category",
      "deleteTitle": "Delete",
      "deleteAria": "Delete category",
      "empty": "No categories defined yet.",
      "delete": {
        "title": "Delete Category",
        "description": "Are you sure you want to delete the category \"{{name}}\"? This action cannot be undone.",
        "confirm": "Delete"
      },
      "toast": {
        "deleted": "Category deleted",
        "deleteError": "Failed to delete category"
      }
    },
    "confirm": {
      "bulkApply": "Apply {{count}} change(s) to {{roleCount}} role(s)?",
      "discardChanges": "Discard unsaved changes?"
    },
    "popover": {
      "grantTitle": "Grant permission",
      "denyTitle": "Deny permission",
      "clearTitle": "Clear permission",
      "grantNote": "Granting this permission overrides any inherited denial.",
      "denyNote": "Denying this permission overrides any inherited grant.",
      "clearNote": "Clearing reverts to inherited behaviour."
    },
    "toast": {
      "permissionGranted": "Permission granted",
      "permissionDenied": "Permission denied",
      "permissionCleared": "Permission cleared",
      "bulkApplied": "Bulk changes applied",
      "saveError": "Failed to save changes"
    }
  },
  "confirm": {
    "restartIntegration": "Restart \"{{name}}\"? Active connections will drop briefly while fresh TLS material is loaded.",
    "revokeFhirEndpoint": "Revoke \"{{name}}\"? Outbound calls to this endpoint will stop.",
    "rotateSmartSecret": "Rotate client secret for \"{{name}}\"? The old secret will stop working immediately.",
    "revokeSmartApp": "Revoke \"{{name}}\"? Future token requests from this app will fail.",
    "deactivateThirdPartyApp": "Deactivate \"{{name}}\"?"
  },
  "toast": {
    "tierCreated": "Tier created",
    "tierCloned": "Tier cloned",
    "tierDeleted": "Tier deleted",
    "tierStatusUpdated": "Status updated",
    "tierFeaturesUpdated": "Features updated",
    "tierLimitsUpdated": "Limits updated",
    "tierSaveError": "Failed to create tier",
    "tierValidation": "Name and code are required",
    "licenseKeyGenerated": "Licence key generated",
    "licenseKeyCopied": "Licence key generated and copied to clipboard",
    "overridesSaved": "Overrides saved",
    "pricingConfigSaved": "Config saved",
    "pricingPriceUpdated": "Price updated",
    "pricingRuleCreated": "Pricing rule created",
    "addonUpdated": "Add-on updated",
    "invalidNumber": "Please enter a valid number",
    "csvExported": "Exported {{filename}}",
    "integrationUpdated": "Integration updated",
    "integrationAdded": "Integration added",
    "integrationInvalidConfig": "Invalid configuration — check host/port and TLS fields",
    "integrationDuplicateName": "An integration with that name already exists",
    "integrationSaveFailed": "Failed to save integration",
    "smartAppRegistered": "SMART app registered",
    "smartAppRegisterFailed": "Failed to register SMART app",
    "smartAppUpdated": "SMART app updated",
    "smartAppUpdateFailed": "Failed to update SMART app",
    "fhirEndpointUpdated": "Endpoint updated",
    "fhirEndpointRegistered": "Endpoint registered",
    "fhirEndpointInvalidConfig": "Invalid configuration — check base URL and auth fields",
    "fhirEndpointDuplicateName": "An endpoint with that name already exists",
    "fhirEndpointSaveFailed": "Failed to save endpoint",
    "clientIdCopied": "Client ID copied",
    "clientSecretCopied": "Client secret copied",
    "statusRefreshed": "Status refreshed",
    "connTestOk": "Connection test successful",
    "connTestFailed": "Connection test failed - check endpoint configuration",
    "serverRestarted": "Server restarted — fresh TLS material in effect",
    "clientReconnected": "Client reconnected — fresh TLS material in effect",
    "notRunning": "Not running — start the server/client to apply config",
    "restartFailed": "Failed to restart integration",
    "metadataOk": "/metadata OK{{detail}}",
    "metadataFailed": "/metadata failed: {{error}}",
    "metadataProbeFailed": "Failed to probe /metadata",
    "metadataUnknownError": "unknown",
    "fhirRevoked": "FHIR endpoint revoked",
    "fhirRevokeFailed": "Failed to revoke endpoint",
    "smartRevoked": "SMART app revoked",
    "smartRevokeFailed": "Failed to revoke SMART app",
    "secretRotated": "Client secret rotated",
    "rotateSecretFailed": "Failed to rotate secret",
    "messageRequeued": "Message re-queued for retry",
    "messageRetryFailed": "Retry failed",
    "messageSkipped": "Message skipped — queue will advance",
    "messageSkipFailed": "Skip failed",
    "messageAbandoned": "Message abandoned",
    "messageAbandonFailed": "Abandon failed",
    "messageResent": "Message resent as new",
    "messageResendFailed": "Resend failed",
    "reasonRequired": "Reason required",
    "copiedToClipboard": "Copied to clipboard",
    "thirdPartyAppCreated": "Third-party app created successfully",
    "thirdPartyAppUpdated": "Third-party app updated successfully",
    "thirdPartyAppDeactivated": "Third-party app deactivated",
    "thirdPartyAppLaunchUrl": "Launch URL generated: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "Add Facility",
      "editTitle": "Edit Facility",
      "fields": {
        "name": "Name",
        "code": "Code",
        "type": "Type",
        "address": "Address",
        "city": "City",
        "stateProvince": "State/Province",
        "country": "Country",
        "phone": "Phone",
        "timeZone": "Timezone",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "e.g. Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA timezone name (e.g. Asia/Singapore). Used for facility-local dates in census, MAR, and reports."
      },
      "options": {
        "otherIana": "Other (IANA)…",
        "useCuratedList": "Use curated list"
      },
      "errors": {
        "nameMin": "Facility name must be at least {{min}} characters",
        "codeFormat": "Code must be uppercase letters and numbers only",
        "typeRequired": "Facility type is required",
        "countryRequired": "Country is required",
        "timeZoneRequired": "Timezone is required",
        "timeZoneInvalidIana": "Server rejected this timezone. Use a valid IANA name (e.g. Asia/Singapore).",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "Create",
        "update": "Update"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Facility created",
        "updatedSuccess": "Facility updated",
        "saveError": "Failed to save facility",
        "invalidTimeZone": "Invalid request — check the timezone is a valid IANA name (e.g. Asia/Singapore)."
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "Facility Management",
      "subtitle": "Facilities, departments, and a glimpse of the physical location hierarchy. For the full location tree (building → floor → unit → room → bed), see <locationsLink>Locations</locationsLink>.",
      "columns": {
        "name": "Name",
        "code": "Code",
        "type": "Type",
        "address": "Address",
        "phone": "Phone",
        "depts": "Depts",
        "status": "Status",
        "actions": "Actions"
      },
      "filter": {
        "search": "Search facilities..."
      },
      "actions": {
        "new": "Add Facility",
        "editTitle": "Edit"
      },
      "expand": {
        "expand": "Expand facility",
        "collapse": "Collapse facility"
      },
      "empty": {
        "noMatch": "No facilities match that search.",
        "none": "No facilities yet — tap Add Facility to get started."
      },
      "departments": {
        "title": "Departments",
        "add": "Add Department",
        "empty": "No departments configured",
        "locationsCount": "{{count}} locations",
        "editTitle": "Edit department"
      },
      "locations": {
        "title": "Locations",
        "add": "Add",
        "empty": "No locations in this department. The location tree (building → floor → unit → bed) is managed in <locationsLink>Locations</locationsLink>."
      }
    },
    "type": {
      "generalHospital": "General Hospital",
      "teachingHospital": "Teaching Hospital",
      "specialtyHospital": "Specialty Hospital",
      "communityHospital": "Community Hospital",
      "clinic": "Clinic"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "Add Health System",
      "editTitle": "Edit Health System",
      "subtitle": "Top of the organisation tree. Parent to one or more facilities.",
      "sections": {
        "identity": "Identity",
        "primaryContact": "Primary contact",
        "address": "Address"
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "taxId": "Tax ID",
        "contactName": "Name",
        "contactEmail": "Email",
        "contactPhone": "Phone",
        "addressLine1": "Address line 1",
        "addressLine2": "Address line 2",
        "city": "City",
        "stateProvince": "State / Province",
        "postalCode": "Postal code",
        "country": "Country",
        "active": "Active — uncheck to soft-disable."
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "Code is immutable after creation."
      },
      "errors": {
        "codeRequired": "Code is required",
        "nameRequired": "Name is required"
      },
      "submit": {
        "create": "Create Health System",
        "update": "Save Changes"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Health system created",
        "updatedSuccess": "Health system updated",
        "saveError": "Failed to save health system",
        "codeConflict": "System code already exists",
        "invalidData": "Invalid health system data"
      }
    },
    "list": {
      "title": "Health Systems",
      "subtitle": "Top of the organisation tree — enterprise / health-system parents that own one or more facilities. Rarely changed after initial setup.",
      "columns": {
        "name": "Name",
        "code": "Code",
        "contact": "Contact",
        "location": "Location",
        "facilities": "Facilities",
        "status": "Status",
        "actions": "Actions"
      },
      "filter": {
        "search": "Search by name or code..."
      },
      "actions": {
        "new": "Add Health System",
        "editTitle": "Edit"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "empty": {
        "noMatch": "No health systems match that search.",
        "none": "No health systems yet — click Add Health System to get started."
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "Add Location",
      "editTitle": "Edit Location",
      "subtitle": "Physical location — building, floor, unit, room, or bed. FHIR R4 Location-compatible. Nest via parent location to build the tree.",
      "sections": {
        "hierarchy": "Hierarchy",
        "identity": "Identity",
        "classification": "Classification",
        "physicalAttributes": "Physical attributes"
      },
      "fields": {
        "facility": "Facility",
        "parentLocation": "Parent location",
        "department": "Department (optional)",
        "code": "Code",
        "abbreviation": "Abbreviation",
        "name": "Name",
        "physicalType": "Physical type (FHIR)",
        "clinicalType": "Clinical type",
        "status": "Status (FHIR)",
        "operationalStatus": "Operational status (HL7 0116)",
        "building": "Building",
        "floor": "Floor",
        "wing": "Wing",
        "roomNumber": "Room number",
        "bedIdentifier": "Bed identifier",
        "capacity": "Capacity",
        "active": "Active (legacy flag)"
      },
      "placeholders": {
        "facility": "Select facility…",
        "parentNone": "None (top-level)",
        "departmentNone": "None",
        "code": "4W-12-A",
        "name": "4W-12 Bed A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType value set.",
        "clinicalType": "Legacy; drop when service_type arrives."
      },
      "physicalAttributes": {
        "show": "Show ▾",
        "hide": "Hide ▴"
      },
      "errors": {
        "facilityRequired": "Facility is required",
        "codeRequired": "Code is required",
        "nameRequired": "Name is required"
      },
      "submit": {
        "create": "Create Location",
        "update": "Save Changes"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Location created",
        "updatedSuccess": "Location updated",
        "saveError": "Failed to save location",
        "codeConflict": "Location code already exists",
        "invalidData": "Invalid location data"
      }
    },
    "list": {
      "title": "Location Hierarchy",
      "subtitle": "Physical tree: building → floor → unit → room → bed. FHIR LocationPhysicalType-aligned. Click a bed's status badge to cycle occupancy. Facilities and departments are managed in <facilitiesLink>Facilities</facilitiesLink>.",
      "filter": {
        "search": "Search by name or code...",
        "allFacilities": "All facilities"
      },
      "actions": {
        "new": "Add Location",
        "addChildTitle": "Add child",
        "editTitle": "Edit"
      },
      "expand": {
        "expand": "Expand location",
        "collapse": "Collapse location"
      },
      "bed": {
        "toggleTitle": "Click to toggle to {{next}}"
      },
      "empty": {
        "noMatch": "No locations match that search.",
        "none": "No locations in this facility yet."
      },
      "toast": {
        "bedStatusUpdated": "Bed status updated",
        "bedStatusError": "Failed to update bed status"
      }
    },
    "type": {
      "si": "Site",
      "bu": "Building",
      "wi": "Wing",
      "wa": "Ward",
      "lvl": "Level/Floor",
      "co": "Corridor",
      "ro": "Room",
      "bd": "Bed",
      "ve": "Virtual",
      "ho": "House",
      "ca": "Cabinet",
      "rd": "Road",
      "area": "Area",
      "jdn": "Jurisdiction"
    },
    "clinicalType": {
      "examRoom": "Exam room",
      "inpatientBed": "Inpatient bed",
      "procedureRoom": "Procedure room",
      "icu": "ICU",
      "ed": "ED",
      "or": "OR",
      "virtual": "Virtual"
    },
    "status": {
      "active": "Active",
      "suspended": "Suspended",
      "inactive": "Inactive",
      "op": {
        "O": "Occupied",
        "U": "Unoccupied",
        "H": "Housekeeping",
        "K": "Contaminated",
        "I": "Isolated",
        "C": "Closed"
      }
    },
    "capability": {
      "isolation": "Isolation-capable",
      "negativePressure": "Negative pressure",
      "bariatric": "Bariatric-capable",
      "telemetry": "Telemetry-capable",
      "icu": "ICU-level"
    }
  },
  "department": {
    "form": {
      "addTitle": "Add Department",
      "editTitle": "Edit Department",
      "subtitle": "Organisational unit within a facility. Can nest (e.g., Cardiology → EP Lab) via parent department.",
      "sections": {
        "department": "Department"
      },
      "fields": {
        "facility": "Facility",
        "code": "Code",
        "abbreviation": "Abbreviation",
        "name": "Name",
        "type": "Type",
        "parentDepartment": "Parent department",
        "costCenterCode": "Cost centre code",
        "revenueDepartmentCode": "Revenue dept code",
        "active": "Active — uncheck to soft-disable."
      },
      "placeholders": {
        "facility": "Select facility…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "Cardiology",
        "parentNone": "None (top-level)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "Facility is required",
        "codeRequired": "Code is required",
        "nameRequired": "Name is required"
      },
      "submit": {
        "create": "Create Department",
        "update": "Save Changes"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Department created",
        "updatedSuccess": "Department updated",
        "saveError": "Failed to save department",
        "codeConflict": "Department code already exists",
        "invalidData": "Invalid department data"
      }
    },
    "serviceType": {
      "clinical": "Clinical",
      "administrative": "Administrative",
      "support": "Support"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    }
  },
  "provider": {
    "form": {
      "addTitle": "Add Provider",
      "editTitle": "Edit Provider",
      "fields": {
        "fullName": "Full Name",
        "npi": "NPI",
        "providerType": "Provider Type",
        "credentials": "Credentials",
        "specialty": "Specialty",
        "email": "Email",
        "phone": "Phone",
        "facilityAssignments": "Facility Assignments",
        "status": "Status",
        "primaryFacility": "Primary Facility",
        "loginAccount": "Login Account"
      },
      "placeholders": {
        "specialty": "Select specialty…",
        "credentials": "e.g. MBBS, FAMS",
        "providerType": "Select provider type",
        "noLoginAccount": "No login account"
      },
      "submit": {
        "create": "Create",
        "update": "Update"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Provider created",
        "updatedSuccess": "Provider updated",
        "saveError": "Failed to save provider"
      },
      "hints": {
        "loginAccount": "Links this clinician to the account they sign in with. Without it, cosignature, pharmacist verification and critical-result acknowledgement will refuse them."
      }
    },
    "list": {
      "title": "Provider Management",
      "subtitle": "Manage providers, credentials, and facility assignments",
      "columns": {
        "name": "Name",
        "npi": "NPI",
        "specialty": "Specialty",
        "credentials": "Credentials",
        "facilities": "Facilities",
        "status": "Status",
        "actions": "Actions"
      },
      "filter": {
        "search": "Search by name, NPI, specialty...",
        "allSpecialties": "All Specialties",
        "allFacilities": "All Facilities",
        "allStatus": "All Status"
      },
      "actions": {
        "new": "Add Provider",
        "editTitle": "Edit provider",
        "scheduleTitle": "Schedule template",
        "viewCredentials": "View credentials"
      },
      "credentials": {
        "licenseLabel": "Licence",
        "none": "No credentials on file"
      },
      "empty": "No providers found",
      "pagination": {
        "summary": "{{from}}-{{to}} of {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "Previous page",
        "next": "Next page"
      },
      "toast": {
        "schedulePlaceholder": "Schedule template link (placeholder)"
      },
      "noLogin": "No login",
      "noLoginHint": "This provider has no linked login account, so they cannot cosign, verify or acknowledge."
    },
    "specialty": {
      "internalMedicine": "Internal Medicine",
      "cardiology": "Cardiology",
      "emergencyMedicine": "Emergency Medicine",
      "pediatrics": "Paediatrics",
      "pathology": "Pathology",
      "obstetricsGynecology": "Obstetrics & Gynaecology",
      "surgery": "Surgery",
      "orthopedics": "Orthopaedics",
      "neurology": "Neurology",
      "psychiatry": "Psychiatry",
      "radiology": "Radiology",
      "anesthesiology": "Anaesthesiology",
      "oncology": "Oncology",
      "dermatology": "Dermatology",
      "ophthalmology": "Ophthalmology"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "onLeave": "On Leave"
    },
    "providerType": {
      "physician": "Physician",
      "nurse": "Nurse",
      "nursePractitioner": "Nurse Practitioner",
      "physicianAssistant": "Physician Assistant",
      "pharmacist": "Pharmacist",
      "therapist": "Therapist",
      "technician": "Technician",
      "other": "Other",
      "midwife": "Midwife",
      "dentist": "Dentist",
      "pharmacyTechnician": "Pharmacy Technician",
      "careAssistant": "Nursing/Care Assistant",
      "dietitian": "Dietitian/Nutritionist",
      "socialWorker": "Social Worker",
      "traditionalMedicine": "Traditional Medicine Practitioner"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "Add Service Line",
      "editTitle": "Edit Service Line",
      "subtitle": "High-level clinical grouping (Cardiovascular, Oncology) that parents specific clinical services.",
      "sections": {
        "serviceLine": "Service Line"
      },
      "fields": {
        "healthSystem": "Health System",
        "code": "Code",
        "name": "Name",
        "description": "Description",
        "active": "Active — uncheck to soft-disable."
      },
      "placeholders": {
        "healthSystem": "Select health system…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "Short descriptor — scope, disease focus, etc."
      },
      "errors": {
        "healthSystemRequired": "Health system is required",
        "codeRequired": "Code is required",
        "nameRequired": "Name is required"
      },
      "submit": {
        "create": "Create Service Line",
        "update": "Save Changes"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Service line created",
        "updatedSuccess": "Service line updated",
        "saveError": "Failed to save service line",
        "codeConflict": "Service line code already exists",
        "invalidData": "Invalid service line data"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "Add Clinical Service",
      "editTitle": "Edit Clinical Service",
      "subtitle": "Specific clinical service (Cardiology, EP Lab). Optionally grouped under a service line + tagged with an NUCC specialty code for billing + directory output.",
      "sections": {
        "clinicalService": "Clinical Service",
        "specialtyBilling": "Specialty + Billing"
      },
      "fields": {
        "code": "Code",
        "name": "Name",
        "serviceLine": "Service Line",
        "description": "Description",
        "specialtyCode": "NUCC specialty code",
        "specialtyDescription": "Specialty description",
        "revenueDepartmentCode": "Revenue dept code",
        "active": "Active"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— none —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC taxonomy — drives provider directory + claim rendering."
      },
      "errors": {
        "codeRequired": "Code is required",
        "nameRequired": "Name is required"
      },
      "submit": {
        "create": "Create Clinical Service",
        "update": "Save Changes"
      },
      "cancel": "Cancel",
      "toast": {
        "createdSuccess": "Clinical service created",
        "updatedSuccess": "Clinical service updated",
        "saveError": "Failed to save clinical service",
        "codeConflict": "Clinical service code already exists",
        "invalidData": "Invalid clinical service data"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "Service ↔ Location Assignments",
    "subtitle": "Which clinical services run in which physical locations, with optional day/time windows and capacity. Scheduling reads these to build available slots. Soft-delete only — ending an assignment preserves the history for reports.",
    "header": {
      "newAssignment": "New Assignment",
      "toggleCancel": "Cancel"
    },
    "form": {
      "title": "New assignment",
      "fields": {
        "service": "Clinical Service",
        "location": "Location",
        "dayOfWeekPattern": "Day-of-week pattern",
        "startTime": "Start time",
        "endTime": "End time",
        "capacity": "Capacity %",
        "notes": "Notes",
        "isPrimary": "Primary location for this service"
      },
      "placeholders": {
        "service": "Select service…",
        "location": "Select location…",
        "dayOfWeekPattern": "1,3,5 (Mon/Wed/Fri)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "Comma-sep ISO weekdays; blank = every day."
      },
      "errors": {
        "serviceLocationRequired": "Service + Location required"
      },
      "create": "Create",
      "cancel": "Cancel"
    },
    "filter": {
      "allFacilities": "All facilities",
      "allServices": "All services",
      "allLocations": "All locations",
      "allStatuses": "All statuses",
      "searchService": "Search services…",
      "searchLocation": "Search locations…",
      "facility": "Facility",
      "serviceLine": "Service line"
    },
    "columns": {
      "service": "Service",
      "location": "Location",
      "facility": "Facility",
      "when": "When",
      "capacity": "Capacity",
      "effective": "Effective",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "planned": "Planned",
      "suspended": "Suspended",
      "ended": "Ended"
    },
    "dow": {
      "everyDay": "Every day",
      "monFri": "Mon–Fri",
      "short": {
        "1": "Mon",
        "2": "Tue",
        "3": "Wed",
        "4": "Thu",
        "5": "Fri",
        "6": "Sat",
        "7": "Sun"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "Primary location",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "Set primary",
      "unsetPrimary": "Unset primary",
      "endAssignment": "End assignment"
    },
    "bulkEdit": {
      "title": "Bulk Edit",
      "applyTo": "Apply to selected",
      "selectedServices": "{{count}} service(s)",
      "selectedLocations": "{{count}} location(s)",
      "save": "Save changes",
      "cancel": "Cancel"
    },
    "confirm": {
      "endTitle": "End assignment?",
      "endDescription": "{{service}} → {{location}}. Ending preserves history but removes the pairing from active scheduling.",
      "endConfirm": "End assignment",
      "removeService": "Remove {{service}} from {{location}}?",
      "makePrimary": "Make {{location}} the primary location for {{service}}?"
    },
    "toast": {
      "created": "Assignment created",
      "createError": "Failed to create assignment",
      "ended": "Assignment ended",
      "endError": "Failed to end assignment",
      "primaryError": "Failed to toggle primary",
      "updated": "Assignment updated"
    },
    "empty": "No assignments match these filters. Click New Assignment to add one."
  },
  "integration": {
    "list": {
      "title": "Integration Management",
      "subtitle": "HL7, FHIR, and third-party system integrations",
      "refresh": "Refresh",
      "addEndpoint": "Add Endpoint",
      "searchPlaceholder": "Search integrations...",
      "tabs": {
        "endpoints": "Endpoints",
        "messageLog": "Message Log",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "Total Endpoints",
        "connected": "Connected",
        "errors": "Errors",
        "totalMessages": "Total Messages"
      }
    },
    "columns": {
      "status": "Status",
      "name": "Name",
      "type": "Type",
      "direction": "Direction",
      "url": "URL",
      "tls": "TLS",
      "auth": "Auth",
      "lastMessage": "Last Message",
      "messages": "Messages",
      "errors": "Errors",
      "backlog": "Backlog",
      "health": "Health",
      "actions": "Actions",
      "backlogTitle": "Pending outbound messages + oldest-pending age",
      "healthTitle": "Health status — red if the queue is blocked on a failed message"
    },
    "badge": {
      "tlsCerts": "cert: {{cert}}, key: {{key}}, CA: {{ca}}",
      "yes": "yes",
      "no": "no",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "bearer token stored",
      "bearerNoToken": "bearer (no token set)",
      "mtlsCert": "mTLS client cert",
      "awaitingAck": "{{n}} awaiting ACK",
      "oldest": "oldest {{age}}",
      "never": "Never",
      "blocked": "BLOCKED",
      "waiting": "WAITING",
      "ok": "OK",
      "blockedTitle": "A failed message is blocking this integration's queue. Click to open the filtered log.",
      "waitingTitle": "Messages awaiting enhanced-mode app-ACK from partner. Click to open the filtered log.",
      "okTitle": "All green — click to open this integration's message log.",
      "receives": "Receives"
    },
    "action": {
      "testConnection": "Test connection",
      "restartTls": "Restart — apply freshly-rotated TLS",
      "investigate": "Throughput, latency, and recent failures",
      "edit": "Edit"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "Recent 50 messages",
      "columns": {
        "time": "Time",
        "id": "ID",
        "direction": "Direction",
        "type": "Type",
        "source": "Source",
        "summary": "Summary",
        "status": "Status"
      },
      "dir": {
        "in": "IN",
        "out": "OUT"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 Server Status",
      "serverOnline": "Server Online",
      "supportedResources": "Supported Resources",
      "version": "Version",
      "externalHeader": "External FHIR Endpoints",
      "registerEndpoint": "Register Endpoint",
      "columns": {
        "name": "Name",
        "baseUrl": "Base URL",
        "auth": "Auth",
        "status": "Status",
        "lastChecked": "Last Checked",
        "actions": "Actions"
      },
      "emptyEndpoints": "No external FHIR endpoints registered yet.",
      "revoked": "revoked",
      "statusOk": "OK",
      "statusError": "Error",
      "testMetadata": "Test /metadata",
      "edit": "Edit",
      "revoke": "Revoke"
    },
    "smart": {
      "header": "Registered SMART Apps",
      "registerApp": "Register App",
      "columns": {
        "appName": "App Name",
        "clientId": "Client ID",
        "scopes": "Scopes",
        "status": "Status",
        "lastModified": "Last Modified",
        "actions": "Actions"
      },
      "emptyApps": "No SMART apps registered yet.",
      "edit": "Edit",
      "rotateSecret": "Rotate client secret",
      "revoke": "Revoke"
    },
    "secretModal": {
      "title": "Save this client secret now",
      "body": "This secret is only shown once. If you lose it, rotate the secret to issue a new one.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Copy client ID",
      "copyClientSecret": "Copy client secret",
      "saved": "I've saved it"
    },
    "drawer": {
      "header": "Integration #{{id}}",
      "refresh": "Refresh",
      "close": "Close",
      "queueBlocked": "Queue blocked",
      "queueBlockedBody": "A failed message is stopping this integration from sending. Messages behind it are waiting until an operator acts.",
      "investigate": "Investigate",
      "tiles": {
        "backlog": "Backlog",
        "success24h": "Success 24h",
        "avgLatency24h": "Avg latency 24h",
        "awaitingAck": "Awaiting app-ACK"
      },
      "charts": {
        "throughput": "Throughput (24h)",
        "throughputSub": "Hourly buckets. Stacked: completed + failed outbound; inbound on secondary axis.",
        "successRate": "Success rate (24h)",
        "successRateSub": "Per bucket: completed / (completed + failed). Gaps are idle buckets.",
        "ackLatency": "ACK latency (24h)",
        "ackLatencySub": "Time between send and ACK received. avg is solid, p95 dashed."
      },
      "series": {
        "outCompleted": "Out · completed",
        "outFailed": "Out · failed",
        "inReceived": "In · received",
        "successPct": "Success %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "Recent failures",
      "viewAll": "View all →",
      "noFailures": "No failed messages in the recent window. 🎉"
    }
  },
  "integrationStatus": {
    "connected": "Connected",
    "disconnected": "Disconnected",
    "error": "Error"
  },
  "integrationDirection": {
    "server": "Server",
    "client": "Client"
  },
  "messageStatus": {
    "sent": "Sent",
    "received": "Received",
    "error": "Error",
    "acknowledged": "Acknowledged"
  },
  "smartAppStatus": {
    "active": "Active",
    "revoked": "Revoked"
  },
  "interfaceMessageStatus": {
    "pending": "Pending",
    "processing": "Processing",
    "completed": "Completed",
    "received": "Received",
    "processed": "Processed",
    "failed": "Failed",
    "error": "Error",
    "rejected": "Rejected",
    "deadLetter": "Dead Letter",
    "skipped": "Skipped",
    "awaitingAppAck": "Awaiting App ACK"
  },
  "interfaceDirection": {
    "in": "Inbound",
    "out": "Outbound"
  },
  "attemptOutcome": {
    "sent": "Sent",
    "appNak": "App NAK",
    "timeout": "Timeout",
    "networkError": "Network error"
  },
  "fhirEndpoint": {
    "titleEdit": "Edit FHIR Endpoint",
    "titleRegister": "Register FHIR Endpoint",
    "subtitle": "External FHIR R4 partners the gateway talks to outbound. The Test Connection button on the integrations list probes <code>/metadata</code> with the configured auth + TLS.",
    "back": "Back",
    "cancel": "Cancel",
    "storedBlank": "Stored — leave blank to keep",
    "save": {
      "changes": "Save Changes",
      "register": "Register Endpoint"
    },
    "section": {
      "basics": "Basics",
      "auth": "Authentication",
      "tls": "TLS"
    },
    "fields": {
      "name": "Name",
      "baseUrl": "Base URL",
      "description": "Description",
      "active": "Active — uncheck to soft-revoke.",
      "method": "Method",
      "username": "Username",
      "password": "Password",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// is required (http://localhost accepted for development). Trailing /metadata is appended automatically during Test.",
      "oauth2": "OAuth2 token fetch is wired on the admin side; the runtime fetcher lands in a follow-up. For now, populate and run Test to verify the rest of the config.",
      "tls": "Paste a root CA to pin the partner's server certificate, or paste a client cert + key for mTLS. CA alone works with the system root store for well-known CAs."
    },
    "option": {
      "method": {
        "none": "None",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — optional for most partners",
      "clientCertRequired": "Client certificate (PEM) — required",
      "clientCertMtls": "Client certificate (PEM) — for mTLS",
      "clientKeyRequired": "Client private key (PEM) — required",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "Name is required",
      "baseUrlRequired": "Base URL is required",
      "baseUrlInvalid": "Base URL must be a valid http(s) URL",
      "basicUsername": "Basic auth requires a username",
      "basicPassword": "Basic auth requires a password",
      "bearerToken": "Bearer auth requires a token",
      "clientCertKey": "Client-certificate auth requires cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "Edit SMART App",
    "titleRegister": "Register SMART App",
    "subtitle": "SMART on FHIR client registration. The client ID is generated for you; the client secret is shown exactly once after create or rotate.",
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save Changes",
    "register": "Register",
    "fields": {
      "appName": "App Name",
      "redirectUris": "Redirect URIs",
      "scopes": "Scopes",
      "launchUrl": "Launch URL",
      "logoUrl": "Logo URL",
      "active": "Active — uncheck to soft-revoke this app."
    },
    "placeholder": {
      "appName": "My EHR Launcher"
    },
    "helper": {
      "redirectUris": "One URI per line. https:// required (http://localhost is also accepted for development)."
    },
    "secretModal": {
      "title": "Save this client secret now",
      "body": "This secret is only shown once. If you lose it, rotate the secret to issue a new one.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Copy client ID",
      "copyClientSecret": "Copy client secret",
      "saved": "I've saved it"
    },
    "validation": {
      "nameRequired": "Name is required",
      "redirectUriRequired": "At least one redirect URI is required",
      "scopeRequired": "At least one scope is required"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "Interface Message Log",
      "subtitle": "Inbound + outbound HL7 messages across every active integration.",
      "refresh": "Refresh",
      "loading": "Loading messages…",
      "empty": "No messages match the current filters.",
      "pagination": "{{total}} messages • page {{page}} of {{pages}}",
      "prev": "Prev",
      "next": "Next",
      "archived": "(arch)"
    },
    "relative": {
      "secondsAgo": "{{n}}s ago",
      "minutesAgo": "{{n}}m ago",
      "hoursAgo": "{{n}}h ago"
    },
    "filter": {
      "header": "Filters",
      "direction": "Direction",
      "status": "Status",
      "messageType": "Message type",
      "msh10": "MSH-10 contains",
      "integrationId": "Integration ID",
      "includeArchive": "Include archive",
      "clear": "Clear filters",
      "any": "Any",
      "messageTypePlaceholder": "e.g. ADT^A01",
      "controlIdPlaceholder": "control id"
    },
    "columns": {
      "id": "ID",
      "dir": "Dir",
      "integ": "Integ",
      "type": "Type",
      "msh10": "MSH-10",
      "status": "Status",
      "ack": "ACK",
      "attempts": "Attempts",
      "when": "When"
    },
    "detail": {
      "eyebrow": "{{direction}} message",
      "close": "Close",
      "loading": "Loading…",
      "tabs": {
        "overview": "Overview",
        "rawHl7": "Raw HL7",
        "attempts": "Attempts"
      },
      "operatorActions": "Operator actions",
      "retry": "Retry",
      "skip": "Skip",
      "abandon": "Abandon",
      "resendAsNew": "Resend as new",
      "skipReason": "Skip reason",
      "abandonReason": "Abandon reason",
      "actionsHelper": "Actions audit with your user ID + reason. Skip + Abandon require a reason.",
      "overview": {
        "direction": "Direction",
        "integration": "Integration",
        "type": "Type",
        "msh10": "MSH-10",
        "status": "Status",
        "ackCode": "ACK code",
        "attempts": "Attempts",
        "created": "Created",
        "ackReceived": "ACK received",
        "nextRetry": "Next retry",
        "ackText": "ACK text",
        "lastError": "Last error",
        "sourceEventId": "Source event ID"
      },
      "rawViewer": {
        "permissionDenied": "Decrypted raw HL7 requires the <code>INTERFACE_OPERATE</code> permission.",
        "notAvailable": "Raw payload not available for this message.",
        "bytes": "{{bytes}} bytes",
        "copy": "Copy"
      },
      "attempts": {
        "inboundInfo": "Attempt history is tracked for outbound messages only. Inbound messages are processed once per MSH-10; retransmissions return the cached ACK without a new attempt.",
        "totalAttempts": "Total attempts",
        "nextAt": " (next at {{time}})",
        "refresh": "Refresh",
        "loading": "Loading attempts…",
        "error": "Failed to load attempts.",
        "empty": "No attempts recorded yet. The worker writes one row per send; this list populates after the first claim.",
        "columns": {
          "when": "When",
          "outcome": "Outcome",
          "ack": "ACK",
          "duration": "Duration",
          "detail": "Detail"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "Third-Party Applications",
      "subtitle": "Configure external applications that can be launched from VynaEMR with patient context",
      "addApp": "Add Application",
      "searchPlaceholder": "Search apps by name, code, or category...",
      "emptyTitle": "No applications configured",
      "emptyBody": "Add external applications like PACS viewers, lab portals, or pharmacy systems.",
      "columns": {
        "application": "Application",
        "category": "Category",
        "url": "URL",
        "security": "Security",
        "display": "Display",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT signed",
      "hmac": "HMAC",
      "hmacSigned": "HMAC signed",
      "none": "None",
      "chart": "Chart",
      "sidebar": "Sidebar",
      "active": "Active",
      "inactive": "Inactive"
    },
    "action": {
      "testLaunch": "Test Launch",
      "edit": "Edit",
      "deactivate": "Deactivate"
    },
    "form": {
      "titleEdit": "Edit Application",
      "titleNew": "New Application",
      "fields": {
        "appCode": "App Code",
        "appName": "App Name",
        "category": "Category",
        "baseUrl": "Base URL",
        "launchMethod": "Launch Method",
        "paramMappings": "Parameter Mappings",
        "enableJwt": "Enable JWT Token Signing",
        "sharedSecret": "Shared Secret (JWT signing key)",
        "enableHmac": "Enable URL Signature (HMAC)",
        "hmacKey": "HMAC Key",
        "requiredPermission": "Required Permission",
        "displayOrder": "Display Order",
        "showInChart": "Show in Chart",
        "showInSidebar": "Show in Sidebar"
      },
      "placeholder": {
        "appCode": "e.g. pacs_viewer",
        "appName": "e.g. PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL param name",
        "unchanged": "(unchanged)",
        "sharedSecret": "Enter shared secret",
        "hmacKey": "Enter HMAC key",
        "requiredPermission": "e.g. RESULT_VIEW (empty = any user)"
      },
      "addParameter": "Add Parameter",
      "cancel": "Cancel",
      "submitUpdate": "Update Application",
      "submitCreate": "Create Application"
    },
    "paramSource": {
      "patientMrn": "Patient MRN",
      "patientName": "Patient Name",
      "patientDob": "Patient DOB",
      "encounterId": "Encounter ID",
      "encounterNumber": "Encounter Number",
      "orderNumber": "Order Number",
      "userName": "Current User Name",
      "userId": "Current User ID",
      "timestamp": "Current Timestamp"
    },
    "launch": "Launch {{name}}"
  },
  "integrationForm": {
    "titleEdit": "Edit Integration",
    "titleAdd": "Add Integration",
    "subtitle": "MLLP and HL7-over-HTTP interfaces backed by VynaHL7. Certificate material is stored on the integration row; rotations take effect the next time the server or client is restarted.",
    "back": "Back",
    "cancel": "Cancel",
    "saveChanges": "Save Changes",
    "addIntegration": "Add Integration",
    "storedBlank": "Stored — leave blank to keep",
    "selectSibling": "— select a sibling integration —",
    "section": {
      "basics": "Basics",
      "connection": "Connection",
      "tls": "TLS / mTLS",
      "auth": "Authentication",
      "ackDelivery": "Acknowledgement & Delivery",
      "outboundRouting": "Outbound routing",
      "inboundTrust": "Inbound trust"
    },
    "fields": {
      "name": "Name",
      "type": "Type",
      "direction": "Direction",
      "description": "Description",
      "active": "Active — uncheck to soft-disable this interface.",
      "host": "Host",
      "port": "Port",
      "enableTls": "Enable TLS — uses",
      "serverCert": "Server certificate (PEM)",
      "clientCert": "Client certificate (PEM) — optional for mTLS",
      "serverKey": "Server private key (PEM)",
      "clientKey": "Client private key (PEM)",
      "serverCa": "Client CA trust store (PEM) — for mTLS",
      "clientCa": "Server CA trust store (PEM) — optional, falls back to system roots",
      "method": "Method",
      "username": "Username",
      "password": "Password",
      "bearerToken": "Bearer token",
      "inboundAck": "Inbound ACK policy",
      "outboundAck": "Outbound ACK policy",
      "processingTimeout": "Processing timeout (ms)",
      "pendingAckTtl": "Pending ACK TTL (seconds)",
      "networkRetry": "Network retry max",
      "appNakRetry": "App NAK retry max",
      "reverseIntegration": "Reverse channel integration",
      "outboundTypes": "Message types received",
      "outboundEvents": "Event-level subscriptions",
      "receivingApplication": "Receiving application (MSH-5)",
      "receivingFacility": "Receiving facility (MSH-6)",
      "inboundTrustProfile": "This partner may"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "Short note about this interface — owner, purpose, message types, etc.",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "Bind address. Use 0.0.0.0 to listen on all interfaces.",
      "hostClient": "Remote host this client should connect to.",
      "tlsHandshake": "for the handshake.",
      "authClientCert": "Client cert/key come from the TLS section above.",
      "authNone": "No HTTP auth header attached.",
      "authRs7": "{{call}} wires this into every outbound request.",
      "ackDefaults": "Controls how the gateway ACKs inbound HL7 messages and how it interprets response ACKs on outbound sends. Defaults",
      "ackDefaultsTail": "match the pre-0.19.0 behaviour — change these per partner as needed.",
      "processingTimeout": "Cap for sync app-ACK inline processing. Timeout → AE + background queue retry.",
      "pendingAckTtl": "Enhanced-mode app-ACK wait before sweeper times it out.",
      "networkRetry": "Retries for transport errors before the queue blocks.",
      "appNakRetry": "Retries for AE/AR/CE/CR — usually 2–3 since the same payload rarely succeeds on retry.",
      "reverse": "Enhanced mode delivers the real app-ACK via a sibling integration pointed at the partner's reverse endpoint. Create the sibling as a separate integration row first, then link it here.",
      "outboundRouting": "What this partner receives. Nothing selected means this integration is not an outbound destination and no message is ever sent to it.",
      "outboundEvents": "Optional, comma-separated. Narrower than a whole type — for a partner that wants only certain events.",
      "receivingDefaults": "MSH-5 and MSH-6 name the receiver on every message sent here. Leave blank to use the interface name.",
      "inboundTrust": "What this partner may assert about patient identity. Authentication says who is connecting; this says what they are allowed to tell us. Leave it on the deployment default unless this peer is genuinely a registration master."
    },
    "option": {
      "type": {
        "mllp": "MLLP (HL7 v2 over TCP)",
        "hoh": "HoH (HL7 over HTTPS)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "Client (outbound)",
        "server": "Server (inbound)"
      },
      "method": {
        "none": "None",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "AA immediately (today's default)",
        "honorMsh16": "read MSH-15/16 per message",
        "forceSync": "process inline, AA/AE/AR on outcome",
        "forceEnhanced": "CA now + app-ACK via reverse channel"
      },
      "outbound": {
        "fireAndForget": "send + forget (today's default)",
        "expectSync": "set MSH-16=AL, retry on AE/AR",
        "expectEnhanced": "await CA + follow-up app-ACK"
      }
    },
    "validation": {
      "nameRequired": "Name is required",
      "hostRequired": "Host is required",
      "mllpPort": "MLLP integrations require a port",
      "portNumber": "Port must be a number",
      "tlsServerCertKey": "TLS server requires both cert and key",
      "basicUsername": "Basic auth requires a username",
      "basicPassword": "Basic auth requires a password",
      "bearerToken": "Bearer auth requires a token",
      "enhancedReverse": "Enhanced ACK mode requires a reverse integration — pick one below.",
      "outboundEvent": "\"{{value}}\" is not a message this system sends — use a type such as ADT, or an event such as ADT^A01."
    },
    "trust": {
      "useDeploymentDefault": "Use the deployment default",
      "observer": "Observer — never creates or changes a patient",
      "demographics": "Demographics — may correct a patient we hold, including a death notice; never creates",
      "registration": "Registration — may also create patients and merge charts"
    }
  },
  "thirdPartyAppCategory": {
    "imaging": "Imaging",
    "laboratory": "Laboratory",
    "pharmacy": "Pharmacy",
    "specialty": "Specialty",
    "portal": "Portal",
    "billing": "Billing",
    "other": "Other"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "Redirect",
    "popup": "Popup Window",
    "iframe": "Iframe",
    "newTab": "New Tab"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "Edit CDS Rule",
      "titleCreate": "Create CDS Rule",
      "ruleName": "Rule Name",
      "ruleType": "Rule Type",
      "selectPlaceholder": "Select...",
      "severity": "Severity",
      "triggerEvent": "Trigger Event",
      "actionType": "Action Type",
      "description": "Description",
      "active": "Active",
      "cancel": "Cancel",
      "submitUpdate": "Update Rule",
      "submitCreate": "Create Rule",
      "createdOk": "Rule created successfully",
      "createFailed": "Failed to create rule",
      "updatedOk": "Rule updated successfully",
      "updateFailed": "Failed to update rule",
      "validation": {
        "nameRequired": "Rule name is required",
        "typeRequired": "Rule type is required",
        "descriptionRequired": "Description is required",
        "triggerRequired": "Trigger event is required",
        "actionRequired": "Action type is required"
      }
    },
    "list": {
      "title": "CDS Rules",
      "subtitle": "Manage clinical decision support rules",
      "addRule": "Add Rule",
      "loading": "Loading CDS rules...",
      "loadError": "Failed to load CDS rules.",
      "empty": "No CDS rules configured.",
      "columns": {
        "ruleName": "Rule Name",
        "type": "Type",
        "severity": "Severity",
        "description": "Description",
        "status": "Status",
        "actions": "Actions"
      },
      "toggleActive": "Click to deactivate",
      "toggleInactive": "Click to activate",
      "active": "Active",
      "inactive": "Inactive",
      "editRule": "Edit rule",
      "statusUpdated": "Rule status updated",
      "statusUpdateFailed": "Failed to update rule status"
    }
  },
  "cdsSeverity": {
    "info": "Info",
    "warning": "Warning",
    "critical": "Critical"
  },
  "cdsTriggerEvent": {
    "orderSign": "Order Sign",
    "orderSelect": "Order Select",
    "patientView": "Patient View",
    "medicationPrescribe": "Medication Prescribe",
    "resultReceived": "Result Received",
    "patientAdmit": "Patient Admission"
  },
  "cdsActionType": {
    "alert": "Alert",
    "warning": "Warning",
    "hardStop": "Hard Stop",
    "suggestion": "Suggestion",
    "notification": "Notification"
  },
  "cdsRuleType": {
    "drugInteraction": "Drug Interaction",
    "drugAllergy": "Drug Allergy",
    "duplicateOrder": "Duplicate Order",
    "custom": "Custom",
    "clinicalAlert": "Clinical Alert",
    "sepsisScreen": "Sepsis Screen"
  },
  "system": {
    "title": "System Configuration",
    "subtitle": "Application settings, security, and system health",
    "restartServices": "Restart Services",
    "restartToast": "Restart services (placeholder - requires confirmation)",
    "loadError": "Could not load system configuration.",
    "section": {
      "systemInfo": "System Information",
      "systemInfoDesc": "Version, uptime, and service health",
      "general": "General Settings",
      "generalDesc": "Application name, timezone, and branding",
      "security": "Security Settings",
      "securityDesc": "Password policy, MFA, and session management",
      "notifications": "Notification Settings",
      "notificationsDesc": "Email and SMS gateway configuration",
      "integration": "Integration Defaults",
      "integrationDesc": "MLLP, FHIR, and HL7 default configuration",
      "featureFlags": "Feature Flags",
      "featureFlagsDesc": "Enable or disable system features",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "Version",
      "uptime": "Uptime",
      "database": "Database",
      "redis": "Redis",
      "microservices": "Microservices",
      "conn": "conn"
    },
    "uptime": {
      "running": "Running",
      "unknown": "Unknown",
      "up": "Up"
    },
    "subsection": {
      "passwordPolicy": "Password Policy",
      "mfa": "Multi-Factor Authentication",
      "sessionLockout": "Session & Lockout",
      "emailConfig": "Email Configuration",
      "smsGateway": "SMS Gateway",
      "mllpDefaults": "MLLP Defaults",
      "fhirConfig": "FHIR Configuration",
      "hl7Encoding": "HL7 v2 Encoding"
    },
    "fields": {
      "appName": "Application Name",
      "timezone": "Timezone",
      "dateFormat": "Date Format",
      "supportEmail": "Support Email",
      "logoUrl": "Logo URL",
      "maintenanceMode": "Maintenance Mode (disables user access)",
      "upload": "Upload",
      "minPasswordLength": "Min Password Length",
      "passwordExpiry": "Password Expiry (days)",
      "requireUppercase": "Require uppercase",
      "requireNumbers": "Require numbers",
      "requireSpecialChars": "Require special chars",
      "enableMfa": "Enable MFA",
      "mfaMethod": "MFA Method",
      "sessionTimeout": "Session Timeout (min)",
      "maxLoginAttempts": "Max Login Attempts",
      "lockoutDuration": "Lockout Duration (min)",
      "smtpHost": "SMTP Host",
      "smtpPort": "SMTP Port",
      "smtpUser": "SMTP User",
      "fromEmail": "From Email",
      "useTls": "Use TLS",
      "enabled": "Enabled",
      "provider": "Provider",
      "fromNumber": "From Number",
      "defaultPort": "Default Port",
      "timeoutSeconds": "Timeout (seconds)",
      "retryCount": "Retry Count",
      "fhirBaseUrl": "FHIR Base URL",
      "authMethod": "Auth Method",
      "fieldSeparator": "Field Separator",
      "encodingChars": "Encoding Characters",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "Asia/Singapore (UTC+8)",
        "hongKong": "Asia/Hong Kong (UTC+8)",
        "kualaLumpur": "Asia/Kuala Lumpur (UTC+8)",
        "bangkok": "Asia/Bangkok (UTC+7)",
        "tokyo": "Asia/Tokyo (UTC+9)",
        "kolkata": "Asia/Kolkata (UTC+5:30)",
        "sydney": "Australia/Sydney (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (Authenticator App)",
        "sms": "SMS",
        "email": "Email"
      },
      "fhirAuth": {
        "none": "None",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "Save General",
      "security": "Save Security",
      "notifications": "Save Notifications",
      "integration": "Save Integration",
      "features": "Save Features",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "General",
      "security": "Security",
      "notifications": "Notifications",
      "integration": "Integration",
      "features": "Features",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "Upload logo (placeholder)",
      "saved": "{{section}} settings saved successfully",
      "saveFailed": "Failed to save settings"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "Patient Merge",
        "description": "Enable patient merge/unmerge functionality"
      },
      "breakGlass": {
        "label": "Break-Glass Access",
        "description": "Allow emergency override for restricted records"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "Expose FHIR R4 endpoints for external systems"
      },
      "smartApps": {
        "label": "SMART on FHIR Apps",
        "description": "Allow third-party SMART apps to connect"
      },
      "clinicalDecisionSupport": {
        "label": "Clinical Decision Support",
        "description": "Enable CDS hooks for order entry"
      },
      "telemedicine": {
        "label": "Telemedicine Module",
        "description": "Video consultation and remote monitoring"
      },
      "patientPortal": {
        "label": "Patient Portal",
        "description": "Patient-facing portal for records and appointments"
      },
      "analyticsDashboard": {
        "label": "Analytics Dashboard",
        "description": "Advanced analytics and reporting dashboards"
      },
      "medicationBarcode": {
        "label": "Medication Barcode Scanning",
        "description": "Barcode verification for medication administration"
      },
      "autoCoding": {
        "label": "Auto-Coding (ICD/CPT)",
        "description": "AI-assisted diagnosis and procedure coding"
      }
    }
  },
  "audit": {
    "title": "Audit Log",
    "subtitle": "System activity log with detailed change tracking",
    "exportCsv": "Export CSV",
    "exportToast": "Exporting {{count}} audit entries as CSV (placeholder)",
    "searchPlaceholder": "Search by user...",
    "advanced": "Advanced",
    "breakGlassOnly": "Break-glass only",
    "fromTo": "From / To:",
    "fromDate": "From date",
    "toDate": "To date",
    "clearFilters": "Clear all filters",
    "entriesFound": "{{count}} entries found",
    "noMatch": "No audit entries match your filters",
    "viewDetails": "View details",
    "detail": {
      "title": "Audit Entry Detail",
      "timestamp": "Timestamp",
      "user": "User",
      "action": "Action",
      "resource": "Resource",
      "ipAddress": "IP Address",
      "breakGlass": "Break-Glass",
      "yes": "Yes",
      "no": "No",
      "details": "Details",
      "dataChanges": "Data Changes",
      "before": "Before",
      "after": "After",
      "result": "Result"
    },
    "columns": {
      "timestamp": "Timestamp",
      "user": "User",
      "action": "Action",
      "resource": "Resource",
      "resourceId": "Resource ID",
      "ipAddress": "IP Address",
      "details": "Details",
      "view": "View"
    },
    "filter": {
      "action": {
        "all": "All Actions",
        "create": "Create",
        "read": "Read",
        "update": "Update",
        "delete": "Delete",
        "login": "Login",
        "logout": "Logout",
        "export": "Export",
        "breakGlass": "Break-Glass"
      },
      "resource": {
        "all": "All Resources",
        "patient": "Patient",
        "encounter": "Encounter",
        "order": "Order",
        "result": "Result",
        "medication": "Medication",
        "user": "User",
        "system": "System"
      }
    },
    "pagination": {
      "first": "First",
      "last": "Last",
      "pageOf": "Page {{page}} of {{pages}}",
      "range": "{{from}}-{{to}} of {{total}}"
    }
  },
  "taxonomy": {
    "title": "Clinical Taxonomy",
    "subtitle": "Service lines group related clinical services (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic). Both feed the service ↔ location assignment matrix used by scheduling.",
    "addServiceLine": "Add Service Line",
    "addClinicalService": "Add Clinical Service",
    "tabs": {
      "serviceLines": "Service Lines",
      "clinicalServices": "Clinical Services"
    },
    "searchLines": "Search service lines...",
    "searchServices": "Search clinical services...",
    "empty": {
      "linesNone": "No service lines configured.",
      "linesNoMatch": "No service lines match.",
      "servicesNone": "No clinical services configured.",
      "servicesNoMatch": "No clinical services match."
    },
    "columns": {
      "name": "Name",
      "code": "Code",
      "description": "Description",
      "services": "Services",
      "status": "Status",
      "serviceLine": "Service Line",
      "specialty": "Specialty",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "editTitle": "Edit"
  },
  "systemStatus": {
    "connected": "Connected",
    "error": "Error"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} staffed",
      "unstaffedBadge": "no holders",
      "unstaffedWarning": "These roles have no holders, so those tiers will page nobody: {{roles}}. Assign the role to staff under Admin → Users."
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
    "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
